import { AbstractApi } from '@/api/AbstractApi'
import request from '@/api/request'

class DashboardApi extends AbstractApi {
  async counts() {
    const route = this.generateAdminRoute({ action: 'counts' })

    return request.get(route)
  }
}

export default new DashboardApi('dashboard')
